import { centerable as c } from "../decorators/centerable.js";
import { stylable as s } from "../decorators/stylable.js";
import { BLOCK_CLASSES as n } from "../../constants.js";
import a from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
import { getBackgroundColor as f } from "./spec-util.js";
let i = (t) => {
  var e, l;
  let r = t.querySelector("a"), o = (e = r == null ? void 0 : r.style) == null ? void 0 : e.backgroundColor;
  return o === "transparent" && (o = (l = r == null ? void 0 : r.style) == null ? void 0 : l.borderColor), o ? f(o) : "";
}, g = (t) => a(t).isValid() ? a(t).getLuminance() > 0.179 ? "color: #000000;" : "color: #ffffff;" : "", y = (t) => {
  var r, o;
  return t.attrs.buttonStyle === "outline" ? `border-color: ${(r = t.attrs) == null ? void 0 : r.backgroundColor}; background-color: transparent; border-style: solid;` : `border-color: transparent; background-color: ${(o = t.attrs) == null ? void 0 : o.backgroundColor}; border-style: solid;`;
};
function b(t) {
  var r, o;
  return ((o = (r = t.querySelector("a")) == null ? void 0 : r.style) == null ? void 0 : o.backgroundColor) === "transparent" ? "outline" : "solid";
}
const $ = s(
  c({
    inline: !1,
    attrs: {
      type: { default: "button" },
      linkUrl: { default: "" },
      text: { default: "" },
      buttonStyle: { default: "solid" }
    },
    group: "block",
    parseDOM: [
      {
        tag: `div.${n.button}`,
        getAttrs(t) {
          return {
            linkUrl: t.getAttribute("data-link-url"),
            text: t.textContent,
            backgroundColor: i(t),
            buttonStyle: b(t)
          };
        }
      },
      {
        tag: "div.intercom-interblocks-button",
        getAttrs(t) {
          let r = t.querySelector("a");
          return {
            linkUrl: r == null ? void 0 : r.getAttribute("href"),
            text: t.textContent,
            backgroundColor: i(t),
            buttonStyle: b(t)
          };
        }
      }
    ],
    toDOM(t) {
      var u;
      let { text: r, fontColor: o } = t.attrs;
      r || (r = "Enter button text");
      let e = o ? `color: ${o};` : g((u = t.attrs) == null ? void 0 : u.backgroundColor), l = y(t);
      return [
        "div",
        {
          class: `${n.blockContainer} ${n.button}`,
          "data-link-url": t.attrs.linkUrl
        },
        [
          "a",
          {
            class: "intercom-h2b-button",
            style: `${l} ${e} `
          },
          r
        ]
      ];
    }
  })
);
export {
  $ as buttonSpec,
  i as getButtonBackgroundColor
};
